module.exports = __webpack_public_path__ + "static/media/cat1.df08143e.jpeg";